import { useEffect } from 'react'
import { useRouter } from 'next/router'
import * as _ from 'lodash-es'
import { gql } from '@apollo/client'
import { useQueryNext } from '../../componentsF/hooksF/useQueryNextF.js'
import { useSaveUserTok } from '../../componentsF/UserAuthWrapperF.jsx'
import { ErrLoadingWrap } from '../../componentsF/ErrLoadingF.jsx'
import { interpolateNextPathname } from '../../nextF/sharedF/interpolateNextPathnameF.mts'

const userTokFromEmailOtpGql = gql(`query ($email: String!, $email_token: String!) {
  gqUserTokFromEmailOtp(email: $email, email_token: $email_token)
}`)

const LoginFromEmailOtp = ({email_token, email, removeLoginParams}) => {
  const {data, error, loading} = useQueryNext(userTokFromEmailOtpGql, {variables: {email_token, email}})
  const {do2SaveUserTok} = useSaveUserTok()

  useEffect(() => {
    const gqUserTok = _.get(data, 'gqUserTokFromEmailOtp')
    if (gqUserTok) {
      do2SaveUserTok({gqUserTok})
      removeLoginParams()
    }
  }, [data])

  return <ErrLoadingWrap {...{loading, error}} />
}

export const CheckEmailTokenWrapper = ({children}) => {
  const {pathname, query: {email_token, email, ...restQuery}} = useRouter()

  if (email_token) {
    const removeLoginParams = () => {
      location.href = interpolateNextPathname({pathname, query: restQuery})
    }
    return <LoginFromEmailOtp {...{email_token, email, removeLoginParams}} />
  }

  return children
}
